import { Outlet } from 'react-router-dom'

import { ComicEpisodeGenerateQueueProvider } from '../context/ComicEpisodeGenerateQueueContext'
import { ImageLightboxProvider } from '../context/ImageLightboxContext'
import { PlatformConfigProvider } from '../context/PlatformConfigContext'
import { TimelineProvider } from '../context/TimelineContext'
import { WorkflowActiveRunIslandProvider } from '../context/WorkflowActiveRunIslandContext'
import {
  UserAuthorizationProvider,
  useUserAuthorization,
} from '../context/UserAuthorizationContext'
import { useTheme } from '../theme/ThemeContext'
import { DynamicIslandProvider, ThemedPermissionLoadingState } from './theme'
import { ImageLightboxHost } from './ImageLightboxHost'

function AuthenticatedProvidersContent() {
  const { theme } = useTheme()
  const { loaded } = useUserAuthorization()

  if (!loaded) {
    return <ThemedPermissionLoadingState theme={theme} className="flex-1" />
  }

  return (
    <PlatformConfigProvider>
      <TimelineProvider>
        <DynamicIslandProvider>
          <WorkflowActiveRunIslandProvider>
            <ComicEpisodeGenerateQueueProvider>
              <ImageLightboxProvider>
                <Outlet />
                <ImageLightboxHost />
              </ImageLightboxProvider>
            </ComicEpisodeGenerateQueueProvider>
          </WorkflowActiveRunIslandProvider>
        </DynamicIslandProvider>
      </TimelineProvider>
    </PlatformConfigProvider>
  )
}

/** 需登录后才挂载的 Context（避免未登录时并发请求触发 401） */
export function AuthenticatedProviders() {
  return (
    <UserAuthorizationProvider>
      <AuthenticatedProvidersContent />
    </UserAuthorizationProvider>
  )
}
